import { render, staticRenderFns } from "./AdminHeaderNavigation.vue?vue&type=template&id=4d840406&"
import script from "./AdminHeaderNavigation.vue?vue&type=script&lang=ts&"
export * from "./AdminHeaderNavigation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports